// extracted by mini-css-extract-plugin
module.exports = {"dataGridWrapper":"contractsadmin_dataGridWrapper__1dUq0","buttonAdd":"contractsadmin_buttonAdd__32prf"};